<template>
<header :style="{backgroundColor: $parent.headerColor}">


  <router-link to="/" class="logo"><img src="../assets/foot.png" alt=""></router-link>

  <div @click="addActive" class="nav-button hide-desktop">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <!-- <div class="line"></div> -->
  </div>

  <div class="header-navigation hide-mobile">
    <ul>
      <li><a href="#SprayFoam">Spray Foam</a></li>
      <li><a href="#Services">Services</a></li>
      <li><a href="#Contact">Contact</a></li>
      <a href="tel:7855568086"><li class="conversion-button">Call Now</li></a>
    </ul>
  </div>

  <section :class="{navigation: activeNav}" class="container page">
  <div @click="addActive" class="exit">x</div>
    
    <ul>
      <li data-aos="fade-up" data-aos-delay="100"><a href="#SprayFoam">Spray Foam</a></li>
      <li data-aos="fade-up" data-aos-delay="200"><a href="#Services">Services</a></li>
      <li data-aos="fade-up" data-aos-delay="300"><a href="#Contact">Contact</a></li>
    </ul>

  </section>

</header>

</template>

<script>
// import AOS from '../main'

export default {
  name: 'site-header',
  data () {
    return {
      activeNav: false,
      isLoggedIn: false,
      currentUser: false,
      photoUrl: '',
      displayName: '',
      email: '',
      searchHidden: false,
      errorClass: 'errorClass',
      searchExpand: 'searchExpand',
      users: '',
      query: ''
    }
  },
  methods: {
    addActive() {
      this.activeNav = !this.activeNav
    }
  },
  created () {

  }
}
</script>

<style lang="scss" scoped>
  $break-small: 900px;


    .exit {
      z-index: 999999999999;
      background-color: transparent;
      border: 1px solid #fff;
      color: #fff;
      width: 40px;
      height: 40px;
      top: 0;
      right: 0;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 1px;
      font-size: 14px;
      cursor: pointer;
    }
.nav-button {
  position: fixed;
  top: 15px;
  right: 30px;
  width: 40px;
  z-index: 9999999;
  text-align: center;
  padding: 0 5px 5px 5px;

}
.nav-button .line {
  width: 90%;
  height: 2px;
  background-color: #eee;
  margin: 7px;
}

.nav-button .line:nth-child(1) {
  width: 90%;
}
.nav-button .line:nth-child(2) {
  width: 50%;
}
.nav-button .line:nth-child(3) {
  width: 70%;
}
// .nav-button .line:nth-child(4) {
//   width: 60%;
// }

header {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  height: 70px;
  position: fixed;
  top: 0;
  z-index: 9999;
  transition: all .1s ease-in-out;
}
input[type="text"],
input[type="date"],
input[type="datetime"],
input[type="email"],
input[type="number"],
input[type="search"],
input[type="time"],
input[type="url"],
input[type="password"],
textarea,
select {
    position: absolute;
    top: 8px;
    right: 1.5em;
    font-family: "avenir", sans-serif;
    text-transform: lowercase;
    letter-spacing: 2px;
    background: #FFF;
    border-style: none;
    box-shadow: 3px 3px 3px #eee;
    border-radius: 25px;
    font-size: 16px;
    margin: 0;
    outline: 0;
    width: 0;
    padding: 12px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    text-align: center;
    margin-bottom: 15px;
    transition: all 0.25s ease-in-out;
    cursor: pointer;

}
input[type="text"].searchExpand {
  width: 30%;
  padding: 12px 7px;
}

.button {
  margin: 0 10px;
  width: auto;
  height: auto;
  padding: 8px 55px;
  display: inline-block;
  color: #111;
  border: 1px solid #333;
  font-weight: bold;
}
.conversion-button {
  color: #fff;
  padding: 7px 15px;
  border: 1px solid #fff;
  border-radius: 50px;
  position: relative;
  overflow: hidden;
  margin: 0 2em;
  height: 40px;

    &:hover{
      border-color: #F38F00;
    }
    &:before {
      content: "";
      position: absolute;
      width: 0%;
      height: 100%;
      left: 0;
      top: 0;
      transition: all .2s ease-in-out;
      z-index: -1;
      cursor: pointer;
    }
    &:hover:before {
      width: 100%;
      background-color: #F38F00;
    }
}
.sign-in {
  position: absolute;
  top: 10px;
  left: 15px;
}
.logo {
  top: -1px;
  left: 0;
  width: 200px;
  height: 1px;
  border-bottom: 70px solid rgba(10, 10, 10, 0.315);
  border-right: 25px solid transparent;
  position: absolute;
  z-index: 999;
}
.logo img {
  top: 25px;
  left: 20px;
  height: 40px;
  width: auto;
  position: absolute;
}
.search-icon {
  right: 30px;
  top: 5px;
  width: 50px;
  position: absolute;
}

.search {
  padding: 5px 20px;
  border-radius: 20px;
  font-family: 1.2em;
  font-family: Georgia;
  background: white;
  line-height: 3;
  border: none;
  position: absolute;
  top: 12px;
  right: 20px;
  width: 300px;
  transition: .2s ease-in-out;
  font-family: "source sans pro";
  letter-spacing: 0.1em;
  display: none;
}
.search:focus {
    background-color: #EEEEEE;
    border: none;
    outline: none;
    color: #111;
}

#user-image {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  /* border: 2px solid #323232; */
  position: absolute;
  top: 15px;
  left: 30px;
  background-size: contain;
}
.beta {
  color: #fff;
  display: inline-block;
  font-family: 'avenir', sans-serif;
  font-weight: 300;
  font-size: 1em;
  text-transform: uppercase;
  letter-spacing: 0.4em;
  width: 100%;
  position: fixed;
  top: 65px;
  left: 0;
  background-color: #333;
  text-align: left;
  padding: 5px 0 5px 1em;
  display: none;
  /* position: absolute;
  left: 4em; */
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
  height: inherit;
}
li {
  display: flex;
  align-items: center;
  height: inherit;
  border-left: 1px solid #aaa;
  transition: background-color .3s ease-in-out;




}

.navigation {
  width: 100% !important;
  z-index: 99999999999;
}
.header-navigation {
  position: relative;
  float: right;
  height: 100%;
  margin: 0;
}
.header-navigation ul{
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.header-navigation ul li{
  letter-spacing: 1px;
  font-family: 'Roboto Slab', 'Avenir', sans-serif;
  padding: 0 2em;

}


a {
  text-decoration: none;
  cursor: pointer;
  transition: color .25s ease-in-out;

    &:hover {
      color: #F38F00;
    }
}

.social-group a img{
  width: 20px;
  display: block;
}

.container {
  transition: 1s all cubic-bezier(0.3, 0.82, 0.165, 1);
  margin: 0 auto 0 auto;
  padding: 50px 0;
  height: 100%;
  width: 0;
  overflow: hidden;
  position: fixed;
  background-color: #111;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  right: 0;
  z-index: 99999999999;

    ul {
    text-align: left;
      list-style-type: none;
      padding: 0;
      height: 100%;  
      width: 200px;
      left: 20px;
      top: 100px;
      position: absolute;
    li {
      text-decoration: none;
      height: 60px;
      list-style: none;
      margin: 0 auto;
      border: none;
      font-family: 'Roboto Slab', 'Avenir', sans-serif;
      font-size: 20px;
    }
  }
}


.container fieldset{
    border: none;
}
.container legend {
    font-size: 1.4em;
    margin-bottom: 10px;
}
.container label {
    display: block;
    margin-bottom: 8px;
}
.container input[type="text"],
.container input[type="date"],
.container input[type="datetime"],
.container input[type="email"],
.container input[type="number"],
.container input[type="search"],
.container input[type="time"],
.container input[type="url"],
.container input[type="password"],
.container textarea,
.container select {
    font-family: "source sans pro", sans-serif;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: bold;
    /* background: #E5E5E5; */
    border: none;
    border-radius: 4px;
    font-size: 1em;
    margin: 0;
    outline: 0;
    padding: 25px 7px;
    width: 90%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    /* background-color: #e8eeef; */
    -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
    box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
    margin-bottom: 15px;
    cursor: pointer;


}
.container input[type="text"]:focus,
.container input[type="date"]:focus,
.container input[type="datetime"]:focus,
.container input[type="email"]:focus,
.container input[type="number"]:focus,
.container input[type="search"]:focus,
.container input[type="time"]:focus,
.container input[type="url"]:focus,
.container input[type="password"]:focus,
.container textarea:focus,
.container select:focus{
    background: #FFF;
}
.container select{
    -webkit-appearance: menulist-button;
    height:35px;
}
/* .container .number {
    background: #1abc9c;
    color: #fff;
    height: 30px;
    width: 30px;
    display: inline-block;
    font-size: 0.8em;
    margin-right: 4px;
    line-height: 30px;
    text-align: center;
    text-shadow: 0 1px 0 rgba(255,255,255,0.2);
    border-radius: 15px 15px 15px 0px;
} */
.out-link  {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: "source sans pro", "avenir", sans-serif;
  text-transform: uppercase;
  letter-spacing: 4px;
  font-weight: lighter;
  border: none;
  border-radius: 4px;
  font-size: 1.2em;
  margin: 0 auto;
  outline: 0;
  padding: 20px 7px;
  width: 70%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  background-color: unset;
  color: #fff;
  text-align: right;
  transition: all .5s ease-in-out;
  text-decoration: none;
  display: block;
}
.container input[type="submit"],
.container input[type="button"]
{
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: "source sans pro", "avenir", sans-serif;
  text-transform: uppercase;
  letter-spacing: 4px;
  font-weight: lighter;
  border: none;
  border-radius: 4px;
  font-size: 1.2em;
  margin: 0 auto;
  outline: 0;
  padding: 20px 7px;
  width: 70%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  background-color: unset;
  color: #fff;
  text-align: right;
  transition: all .5s ease-in-out;
  cursor: pointer;

}
.container input[type="submit"]:hover,
.container input[type="button"]:hover
{
    color: #999;
}

@media only screen and (max-width: 900px) {

  .button {
    margin: 5px 10px;
    width: auto;
    height: auto;
    padding: 8px 55px;
    display: inline-block;
    /* background-color: #333; */
    color: #111;
    border: 1px solid #333;
    font-weight: bold;
    display: none;
  }

  .conversion-button {
    background-color: #eee;
    border: 3px solid #111;
    display: block;
    color: #333;
    font-size: 12px;
    padding: 8px 20px;
    border-radius: 50px;
  }


}

.text-now-global {
    width: 70%;
    margin: 2em auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    img {
      width: 20px;
      position: absolute;
      left: -30px;
    }
    .underline {
      text-decoration: underline;
    }
  }

  .contrast {
    color: #fff;
    margin: 0;
  }

  .bold {
    font-family: 'Source Sans Pro';
    font-weight: bolder;
    text-transform: uppercase;
    font-size: 18px;
    letter-spacing: 1.6pt;
    text-align: left;
    margin-left: 5px;
  }
</style>
